// extracted by mini-css-extract-plugin
module.exports = {"breadcrumb":"TaskBreadcrumb_breadcrumb__MqkW4"};